(function () {
  'use strict';

  function previewMapFor(designId, color) {
    if (!designId) return null;

    try {
      var raw = localStorage.getItem('blvnks.designPreview.' + designId);
      if (!raw) return null;
      if (raw.charAt(0) !== '{') return { front: raw };

      var parsed = JSON.parse(raw);
      var key = String(color || '').toLowerCase();

      if (parsed.byColor && key && parsed.byColor[key]) {
        return parsed.byColor[key];
      }

      return parsed;
    } catch (error) {
      return null;
    }
  }

  function applyPlacement(figure, preview) {
    if (!preview || !figure) return;

    var img = figure.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      img.alt = figure.getAttribute('data-blv-placement') || 'Custom design';
      img.loading = 'lazy';
      figure.insertBefore(img, figure.firstChild);
    }

    var current = img.getAttribute('src') || '';
    if (/^https?:/i.test(current) && String(preview).indexOf('data:') === 0) {
      figure.dataset.blvDesignHydrated = 'true';
      return;
    }

    if (current !== preview) {
      img.src = preview;
    }

    figure.dataset.blvDesignHydrated = 'true';
  }

  function hydrateCartDesigns() {
    document.querySelectorAll('.blv-cart-placements[data-blv-design-id]').forEach(function (host) {
      var previews = previewMapFor(
        host.getAttribute('data-blv-design-id'),
        host.getAttribute('data-blv-color')
      );
      if (!previews) return;

      host.querySelectorAll('[data-blv-placement]').forEach(function (figure) {
        applyPlacement(figure, previews[figure.getAttribute('data-blv-placement')]);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateCartDesigns);
  } else {
    hydrateCartDesigns();
  }

  document.addEventListener('cart:updated', hydrateCartDesigns);

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(hydrateCartDesigns, 50);
    });
  }

  var raf = 0;
  var observer = new MutationObserver(function () {
    if (raf) return;
    raf = window.requestAnimationFrame(function () {
      raf = 0;
      hydrateCartDesigns();
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  function designedItems(cart) {
    return (cart.items || []).filter(function (item) {
      return item.properties && item.properties['_Design ID'];
    });
  }

  function filesFromProperties(props) {
    var files = [];
    var i;

    for (i = 1; i <= 8; i += 1) {
      if (!props['_File ' + i]) continue;
      files.push({
        name: props['_File ' + i + ' name'] || 'Artwork ' + i,
        url: props['_File ' + i],
        id: props['_File ' + i + ' ID'] || '',
        sides: props['_File ' + i + ' sides']
          ? String(props['_File ' + i + ' sides']).split(', ')
          : []
      });
    }

    return files;
  }

  function designFromProperties(props) {
    if (!props || !props['_Design ID']) return null;

    var sides = props['Design sides'] && props['Design sides'] !== 'None'
      ? String(props['Design sides']).split(', ')
      : [];

    return {
      id: props['_Design ID'],
      color: props.Color || '',
      sides: sides,
      files: filesFromProperties(props),
      proofs: {
        front: props['_Proof Front'] || '',
        back: props['_Proof Back'] || '',
        leftChest: props['_Proof Left Chest'] || '',
        frontId: props['_Proof Front ID'] || '',
        backId: props['_Proof Back ID'] || '',
        leftChestId: props['_Proof Left Chest ID'] || ''
      }
    };
  }

  function payloadFromCart(cart) {
    var items = cart.items || [];
    var designed = designedItems(cart);
    var props = (designed[0] && designed[0].properties) || {};

    return {
      contact: {
        email: props['_Customer email'] || window.blvnksCustomerEmail || ''
      },
      items: items.map(function (item) {
        var lineProps = item.properties || {};
        return {
          variantId: item.variant_id,
          quantity: item.quantity,
          design: designFromProperties(lineProps),
          properties: lineProps
        };
      })
    };
  }

  function designedEndpoint() {
    return (window.routes && window.routes.designed_checkout_url) || '/apps/blvnks/designed';
  }

  function startDesignedCheckout(event) {
    var button = event.target.closest('[name="checkout"], .cart__checkout-button');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.dataset.blvCheckingOut === 'true') return;
    button.dataset.blvCheckingOut = 'true';

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (!designedItems(cart).length) {
          window.location.href = '/checkout';
          return;
        }

        var payload = payloadFromCart(cart);

        return fetch(designedEndpoint(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        }).then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || !data.ok || !data.invoiceUrl) {
              throw new Error(data.message || 'Unable to start designed checkout.');
            }
            window.location.href = data.invoiceUrl;
          });
        });
      })
      .catch(function (error) {
        button.dataset.blvCheckingOut = 'false';
        window.alert(error.message || 'Unable to start designed checkout.');
      });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[name="checkout"], .cart__checkout-button')) return;
    startDesignedCheckout(event);
  }, true);
})();
